import React, { useEffect, useState } from 'react';
import './PasswordForm-styles.css';
import logo from '../../../../assets/images/logo.png';
import { BRAND_NAME } from '../../../../themeSetting';
import { ArrowRight, Smartphone } from 'lucide-react';
import { PhoneInputField } from '../../../profileInfo/components/Forms/GenericInputField/PhoneInputField';
import { Form, Formik } from 'formik';
import PasswordFormvalidationSchema from './PasswordFormvalidationSchema';
import { PasswordField } from '../../../profileInfo/components/Forms/GenericInputField/PasswordField';
import FormLink from '../../../profileInfo/components/Forms/formLink/FormLink';
import { conf } from '../../../../confg';
import axios from 'axios';
import { Toast } from 'react-bootstrap';
import useToast from '../../hook/useToast';
import { ROUTES } from '../../../profileInfo/constant/Routes';
import { connect } from 'react-redux';
import { isAuthenticated } from '../../../../utils/isAuthenticated';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { notNullAndUndefined } from '../../../../helper';
import { set_me } from '../../../../actions/user';

const PasswordForm = ({ hasNameAndFamily, user, set_me }) => {
  const { toasts, showSuccessToast, showErrorToast, hideSuccessToast, hideErrorToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  };
  const fromBasket = getQueryParam('fromBasket');

  const class_toast = 'bg-success';
  const class_toast_error = 'bg-danger';
  const initialValues = {
    password: '',
  };

  const username = getQueryParam('mobile');
  const handleSubmit = (data) => {
    setIsLoading(true);
    let login_conf = {
      url: conf.server_url + 'auth/loginPassword',
      method: 'POST',
      timeout: 0,
      mimeType: 'multipart/form-data',
      contentType: false,
      data: { ...data, username: username },
    };
    axios(login_conf)
      .then((res) => {
        setIsLoading(false);
        console.log('res');
        localStorage.setItem('token', res.data['token']);
        if (fromBasket) {
          window.location.href = `/cart`;
        } else {
          const referrer = location.state?.referrer || '/';
          console.log(referrer);
          window.location.href = referrer;
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        showErrorToast(error.response.data.message);
      })
      .finally((r) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    let tok = localStorage.getItem('token');
    if (notNullAndUndefined(tok)) {
      set_me();
    }
  }, []);

  if (Object.keys(user).length > 0) {
    return <Redirect to='/' />;
  }
  return (
    <div className='login-container-form'>
      <div className='login-card-form'>
        {/* Header */}
        <div className='login-header-form'>
          <div className='back-arrow'>
            <a href={ROUTES.SIGN_IN}>
              <ArrowRight size={24} />
            </a>
          </div>
        </div>

        {/* Logo */}
        <div className='login-content'>
          <div className='logo-container'>
            <div className='logo'>
              <a href='/'>
                <img
                  src={logo}
                  className='img-fluid'
                  style={{ width: '100px' }}
                  alt={BRAND_NAME}
                  onClick={() => {
                    this.setState({ home: true });
                  }}
                />
              </a>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className='form-container-login-form'>
          <div className='input-wrapper'>
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={PasswordFormvalidationSchema}
              onSubmit={handleSubmit}
              validate={(values) => {
                return {};
              }}
            >
              {({ errors, touched }) => {
                const allErrors = {
                  ...errors,
                };
                return (
                  <Form>
                    <p className='subtitle'>رمز عبور را وارد کنید </p>

                    <PasswordField hasLable={false} name='password' placeholder={''} errors={allErrors} touched={touched} />
                    <FormLink linkText={'ورود با رمز یکبار مصرف'} link={`${ROUTES.OTP}?mobile=${username}&shouldSendOtp=true`} />
                    <FormLink linkText={'فراموشی رمز عبور'} link={ROUTES.RESET_PASSWORD} />

                    <button type='submit' className='submit-button-form-login'>
                      {isLoading ? 'در حال ورود' : 'ورود'}
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
      <Toast
        className={'rtl position-fixed color-white z-index-top ' + class_toast}
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 999999999999,
          borderRadius: '12px',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '350px',
          backgroundColor: '#28a745',
          cursor: 'pointer',
        }}
        show={toasts.success.show}
        onClose={hideSuccessToast}
        onClick={hideSuccessToast}
        autohide={true}
        delay={4000}
      >
        <Toast.Body
          style={{
            padding: '12px 20px',
            fontSize: '12px',
            textAlign: 'center',
            color: 'white',
            fontWeight: '500',
          }}
        >
          {toasts.success.message}
        </Toast.Body>
      </Toast>

      <Toast
        className={'rtl position-fixed color-white z-index-top ' + class_toast_error}
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 999999999999,
          borderRadius: '12px',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '350px',
          backgroundColor: '#dc3545', // قرمز
        }}
        show={toasts.error.show}
        onClose={hideErrorToast}
        autohide={true}
        delay={4000}
      >
        <Toast.Body
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 20px',
            fontSize: '11px',
            textAlign: 'center',
            color: 'white',
            fontWeight: '500',
          }}
        >
          <div>{toasts.error.message}</div>
          <button
            onClick={hideErrorToast}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              padding: '4px 5px',
              fontSize: '11px',
              cursor: 'pointer',
              fontWeight: '500',
            }}
          >
            بستن
          </button>
        </Toast.Body>
      </Toast>
    </div>
  );
};
const MapStateToProps = (state) => ({
  hasNameAndFamily: state.user.has_name_and_family,
  user: state.user,
});
export default connect(MapStateToProps, {
  set_me,
})(PasswordForm);
